module.exports = __webpack_public_path__ + "img/Banner-06.a1932af8.png";